import { render, staticRenderFns } from "./MiuTeacherServiceTagManage.vue?vue&type=template&id=bd137184&scoped=true"
import script from "./MiuTeacherServiceTagManage.vue?vue&type=script&lang=js"
export * from "./MiuTeacherServiceTagManage.vue?vue&type=script&lang=js"
import style0 from "./MiuTeacherServiceTagManage.vue?vue&type=style&index=0&id=bd137184&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd137184",
  null
  
)

export default component.exports